import { useEffect } from 'react';

import { useGetClientRemindersQuery } from '@app/api/ClientReminders';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

export const useSettingUpAutomaticMessagingToClientsEffects = () => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { showNotification } = useNotification();

  const {
    data,
    error,
    isLoading: isDataLoading,
  } = useGetClientRemindersQuery(
    {
      ActiveBranchId,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  return {
    data,
    isDataLoading,
  };
};
